import { v4 } from "uuid";

import { IEReservationContext } from "modules/context/types/IEReservationContext";
import { SsoSystem } from "modules/context/types/SsoSystem";
import { PasswordStrength } from "modules/context/types/PasswordStrength";

export const createContext = (
  context?: Partial<IEReservationContext>
): IEReservationContext => {
  return {
    logoMainHref: v4(),
    privatePolicyUrl: v4(),
    privatePolicyInfo: v4(),
    w3cInfoShow: true,
    logoMainFileId: 123123123,
    logoMainDescription: v4(),
    headHtml: v4(),
    footerHtml: v4(),
    corporateMarkEnabled: true,
    regulationsAgreement: "Bleblelble regulationsAgreement",
    personalDataAgreement: "Ble ble ble ble personalDataAgreement",
    ssoSystem: SsoSystem.PZ,
    minPasswordLength: 8,
    minPasswordStrength: PasswordStrength.Medium,
    maxFailedAttempts: 3,
    banTime: 5,
    daysToPasswordChange: 5,
    uniqueLastPasswords: 3,
    blockAppointmentTime: 5,
    validityLinkAppointmentTime: 5,
    loggingInMode: [],
    siteTitle: "Główny Urząd w Gdyni",
    isRecaptchaDisabled: true,
    banBookingToday: false,
    ...context,
  };
};
